import { FooterWrapper } from './Footer.style';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

const FooterComponent = ({ match }, { t }) => (
  <FooterWrapper>
    <footer>
      <p>
        <span>
          <NavLink to={`${match.url}/privacy`}>{t('Privacy')}</NavLink>
        </span>
        <span>
          <NavLink to={`${match.url}/legal`}>{t('Legal')}</NavLink>
        </span>
        <span>
          {t('Copyright') + ' ©'} {new Date().getFullYear()}{' '}
          {t('Health Care Services International Inc.')} (
          {t('o/a Novus Health')})
        </span>
      </p>
    </footer>
  </FooterWrapper>
);

FooterComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/common/Footer/FooterComponent.js